// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ReviewRefuseSvg from '@rsuite/icon-font/lib/flow/ReviewRefuse';
var ReviewRefuse = createSvgIcon({
  as: ReviewRefuseSvg,
  ariaLabel: 'review refuse',
  category: 'flow',
  displayName: 'ReviewRefuse'
});
export default ReviewRefuse;